import React from 'react';
import ReactDOM from 'react-dom/client';

import { RouterProvider } from 'react-router-dom';
import { Container } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';

import { initSentry } from '@utils/sentry';
import queryClient from '@api/queryClient';
import router from './router';
import { AppThemeProvider } from './context/AppThemeProvider';
import './index.css';

if (process.env.NODE_ENV === 'production') initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppThemeProvider>
        <SnackbarProvider />
        <Container maxWidth={false} disableGutters>
          <RouterProvider router={router} />
        </Container>
      </AppThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
